import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { EM_DASH } from 'libs.constants';
import { useLocalizeMessage, Link, Badge, Dropdown, useDialog } from 'libs.nucleus';
import { getStatusBadgeVariant, getStatusLabel } from '../../utils';
export const useDashboardsColumns = ({ archiveDashboard, }) => {
    const translate = useLocalizeMessage();
    const dialog = useDialog();
    const onArchiveDashboard = async (dashboard) => {
        const ok = await dialog.open({
            title: translate('Confirm archival?'),
            body: translate('Are you sure you want to archive this dashboard? Confirming will remove this dashboard from the main list and make it no longer editable. You can still view it via the "Show archived" filter.'),
            actionButtons: [{ isDestructive: true, label: translate('Yes, archive') }, { label: translate('No, cancel') }],
        });
        if (ok) {
            archiveDashboard(dashboard);
        }
    };
    return [
        {
            header: translate('Name'),
            accessorKey: 'name',
            enableSorting: true,
            cell: (value) => {
                const dashboard = value.row.original;
                return (_jsx(Link, { LinkComponent: RouterLink, to: `/library/dashboards/${dashboard.id}`, children: value.getValue() }));
            },
            size: 250,
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            accessorFn: (dashboard) => dashboard.data?.description || EM_DASH,
            enableSorting: false,
            size: 400,
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
            enableSorting: true,
            cell: ({ row }) => _jsx(Badge, { label: `v${row.original.version}` }),
            size: 120,
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            enableSorting: true,
            size: 150,
            cell: (value) => {
                const status = value.getValue();
                return _jsx(Badge, { label: getStatusLabel(status, translate), variant: getStatusBadgeVariant(status) });
            },
        },
        {
            header: '',
            accessorKey: 'id',
            size: 50,
            cell: ({ row }) => {
                const dashboard = row.original;
                const isArchived = dashboard.active === false;
                if (isArchived) {
                    return null;
                }
                const items = [
                    {
                        content: translate('Archive'),
                        id: 'archive-' + dashboard.id,
                        onClick: () => onArchiveDashboard(dashboard),
                    },
                ];
                return _jsx(Dropdown, { variant: 'kebab', position: 'bottom-end', items: items });
            },
            enableSorting: false,
        },
    ];
};
